import { InMemoryCache, ApolloClient, ApolloLink} from '@apollo/client'
import { onError } from '@apollo/client/link/error'
import { setContext } from '@apollo/client/link/context'
import { HttpLink } from '@apollo/client/link/http'
import { env } from './env'

import { ADD_VIDEO_ANALYTICS } from '../mutations/ADD_VIDEO_ANALYTICS'
import { ADD_PRINT_ANALYTICS } from '../mutations/ADD_PRINT_ANALYTICS'
import { ADD_SLIDE_ANALYTICS } from '../mutations/ADD_SLIDE_ANALYTICS'
import moment from 'moment'

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: ApolloLink.from([
    onError(({ graphQLErrors, networkError }) => {
      if (graphQLErrors) {
        graphQLErrors.map(({ message, locations, path }) =>
          // tslint:disable-next-line:no-console
          console.error(
            `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`,
          ),
        )
      }
      // tslint:disable-next-line:no-console
      if (networkError) { console.error(`[Network error]: ${networkError}`) }
    }),
      setContext((_, { headers }) => {
      // get the authentication token from local storage if it exists
      let authToken = localStorage.getItem('authToken')
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('authToken')) {
        authToken = urlParams.get('authToken')
      }

      // return the headers to the context so httpLink can read them
      return {
        headers: {
          ...headers,
          authorization: authToken ? `Bearer ${authToken}` : '',
        },
      }
    }),
    new HttpLink({
      headers: {
        'Accept-Encoding': 'gzip',
      },
      uri: env.REACT_APP_API_HOST + '/graphql',
    }),
  ]),
})



const trackVideo = (
  page: string,
  videoName: string,
  videoLength: number,
  currentTime: number,
  label: string) => {
  apolloClient.mutate({
    mutation: ADD_VIDEO_ANALYTICS , variables: {
      time: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
      page,
      videoName,
      videoLength,
      currentTime,
      label,
    },
  })
}


(window as any).trackVideo = trackVideo


const trackPrint = (
  fileName: string,
  label: string) => {

  const patientID = window.localStorage.patientID ?
    window.localStorage.patientID
      : null

  apolloClient.mutate({
    mutation: ADD_PRINT_ANALYTICS, variables: {
      time: moment().format('YYYY-MM-DDTHH:mm:ssZ'),
      page: window.location.pathname,
      patientID,
      fileName,
      label,
    },
  })
  return true
  }

(window as any).trackPrint = trackPrint

const trackSlide = (
  label: string) => {
  apolloClient.mutate({
    mutation: ADD_SLIDE_ANALYTICS, variables: {
      page: window.location.pathname,
      title: window.location.pathname.includes('20') ? 'Distraction Slides' : 'Mask Education Slides',
      label,
    },
  })
  return true
}

(window as any).trackSlide = trackSlide



// WEBPACK FOOTER //
// ./src/utils/apolloClient.ts